import React from 'react';
import styled from '@emotion/styled';
import ReactMarkdown from 'react-markdown';
import { Grid, responsiveFontSize } from 'style';
import { Spacer200 } from '..';

const CaseIntroComponent = ({
    introHeadline,
    intro,
    client,
    date,
    awards,
    industry,
    website,
    tags,
    isAwardsCase,
}) => {
    console.log(website);
    return intro ? (
        <div className="wrapper" id="CaseIntroComponent">
            <div className="container-fluid">
                <Spacer200 />
                <div className="row between-sm">
                    <ColumnLeft className="col-xs-12 col-md-8">
                        <IntroLabel>{introHeadline}</IntroLabel>
                        <IntroText>{intro}</IntroText>
                        {/* {website && isAwardsCase && (
                            <div style={{ marginTop: '2rem' }}>
                                <LinkButton href={website} target="_blank">
                                    Launch website
                                </LinkButton>
                            </div>
                        )} */}
                    </ColumnLeft>
                    <Column className="col-xs-12 col-md-2">
                        <IntroLabel>Project</IntroLabel>
                        <p>
                            Client: {client}
                            <br />
                            Year: {date}
                            <br />
                            {industry && (
                                <span>
                                    Industry: {industry}
                                    <br />
                                </span>
                            )}
                            {awards && (
                                <ReactMarkdown
                                    source={`Awards: ${awards}`}
                                    renderers={{ root: 'div' }}
                                    containerTagName="span"
                                    className="markdown"
                                />
                            )}
                        </p>

                        <IntroLabel>Deliverables</IntroLabel>
                        <p>
                            {tags.map(tag => (
                                <div key={tag.tag}>{tag.tag}</div>
                            ))}
                        </p>

                        {website && !isAwardsCase && (
                            <div>
                                <a
                                    href={website}
                                    target="_blank"
                                    className="arrow-link">
                                    See the work
                                </a>
                            </div>
                        )}

                        {/* {website && isAwardsCase && (
                            <div>
                                <LinkButton href={website} target="_blank">
                                    See the awards site
                                </LinkButton>
                            </div>
                        )} */}
                    </Column>
                </div>
            </div>
        </div>
    ) : (
        <div></div>
    );
};

const IntroLabel = styled.div`
    color: #9c9c9c;
    margin-bottom: 10px;
`;
const IntroText = styled.div`
    ${responsiveFontSize(22, 32)};
`;

// const Col = styled.div`
//   width: 100%;

//   @media (min-width: 1024px){
//     display: flex;
//     flex-wrap: nowrap;
//   }
// `;

const ColumnLeft = styled.div`
    margin: 0;
    margin-bottom: 4vh;
    // @media (min-width: 1024px){
    //   flex: 1 0 54%;
    //   max-width: 54%;
    // }
`;
const Column = styled.div`
    margin: 0;

    // @media (min-width: 1024px){
    //   margin-top: 0;
    //   flex: 1 0 21%;
    //   max-width: 21%;
    //   margin-left: 10.5%;
    // }
`;

const LinkButton = styled.a`
    padding: 1rem 1.5rem;
    border-radius: 4rem;
    text-decoration: none;
    display: inline-block;
    background-color: black;
    color: white;
    border: 1px solid black;
    transition: all 0.2s ease-out;
    &:hover {
        background-color: white;
        color: black;
    }
`;

export default CaseIntroComponent;
